import { nextTick, ref } from 'vue'
import { usergroupApi } from '@/services/api'

/**
 * use for combo box
 * @param param0 
 * @returns 
 */
export const useInfinityGroups = ({ search = ref(''), limit = ref(20), page = ref(0), isLoading = ref(false), list = ref([]), firmId }) => {
  const haveMore = ref(true)
  const getMoreData = async () => {
    try {
      isLoading.value = true

      const searchRequest = usergroupApi.getPaginated({ search: search.value, limit: limit.value, page: page.value, firmId })
      const searchResponse = await searchRequest.promise
      haveMore.value = searchResponse.count.hasNextPage

      await nextTick() // to be sure have more is updated so the request won't be done again

      list.value = page.value === 0 ? searchResponse.docs : [...list.value, ...searchResponse.docs]

      return searchResponse
    }
    catch (err) {
      console.log('err', err)
    }
    finally {
      isLoading.value = false
    }
  }

  return {
    search,
    limit,
    page,
    haveMore,
    getMoreData,
    list,
    isLoading,
  }
}
